export const EN_US_KICORE = {
 "catalog": {
 "6 meses": "6 months",
 "1 año": "1 year",
 "Próximos 12 meses": "Next 12 months",
 "El correo electrónico no es válido": "The email address is not valid",
 "la versión": "the version",
 "publicada": "published",
 "Escribe la versión para confirmar": "Type the version to confirm",
 "Es la versión en distribución: al borrarla se retira también el puntero del canal y los equipos dejarán de recibir actualizaciones desde aquí.": "It is the version in distribution: deleting it also removes the channel pointer, and devices will stop receiving updates from here.",
 "Se eliminará el paquete y su manifest. Los equipos que ya la tengan instalada no se ven afectados.": "The package and its manifest will be deleted. Devices that already have it installed are unaffected.",
 "Destino": "Audience",
 "Sin declarar": "Not declared",
 "Destino de la versión": "Version audience",
 "Se publicó antes de declarar destino: se trata como dirigida a equipos": "Published before audiences existed: treated as aimed at devices",
 "Esta versión se publicó sin declarar destino, así que se trata como dirigida a equipos": "This version was published without an audience, so it is treated as aimed at devices",
 "Es la versión en distribución, así que el cambio tiene efecto de inmediato": "It is the version in distribution, so the change takes effect immediately",
 "No está en distribución: el cambio tendrá efecto cuando se publique": "Not in distribution: the change will take effect when it is published",
 "¿A qué va dirigido este software?": "What is this software for?",
 "Equipos": "Devices",
 "Aplicaciones de usuario": "User applications",
 "Aplicación de usuario": "User application",
 "Core comprueba que el equipo esté registrado y con la suscripción en regla": "Core checks that the device is registered and its subscription is in order",
 "Se descarga sin comprobar nada en Core, porque no hay equipo que comprobar": "Downloaded without any check in Core, as there is no device to check",
 "Destino del software": "Software audience",
 "Cambiar destino": "Change audience",
 "Destino actualizado": "Audience updated",
 "Consultando el destino actual": "Checking the current audience",
 "Dejará de comprobarse la suscripción": "Subscription will no longer be checked",
 "Cualquiera con un token válido podrá descargar este software, sin pasar por Core.": "Anyone with a valid token will be able to download this software, bypassing Core.",
 "El cambio se aplica a todas las versiones publicadas de este firmware": "The change applies to every published version of this firmware",
 "Gestión de versiones de firmware OTA": "OTA firmware version management",
 "el firmware": "the firmware",
 "el canal": "the channel",
 "la variante": "the variant",
 "la carpeta": "the folder",
 "Eliminar definitivamente": "Delete permanently",
 "Esta acción no se puede deshacer": "This action cannot be undone",
 "Se eliminarán todas las versiones que cuelgan de esta ruta, incluidas las que estén en distribución. Los equipos dejarán de recibir actualizaciones desde aquí.": "All versions under this path will be deleted, including those currently live. Devices will stop receiving updates from here.",
 "Se eliminará": "Will be deleted",
 "Calculando lo que contiene": "Calculating its contents",
 "Escribe la ruta para confirmar": "Type the path to confirm",
 "Nuevo firmware": "New firmware",
 "Nuevo canal": "New channel",
 "Nueva variante": "New variant",
 "Nueva versión": "New version",
 "Sin versiones publicadas": "No published versions",
 "Se creará el firmware": "The firmware will be created",
 "Se creará el canal": "The channel will be created",
 "Se creará la variante": "The variant will be created",
 "Las carpetas del almacén nacen con su primera versión": "Folders in the store are born with their first version",
 "Publicar una versión": "Publish a version",
 "Publicar": "Publish",
 "Nuevo o existente": "New or existing",
 "Sin variante": "No variant",
 "Se publicará en": "Will be published to",
 "Esa versión ya existe en este destino": "That version already exists at this destination",
 "Solo se admiten letras, números, punto, guion y guion bajo": "Only letters, numbers, dot, hyphen and underscore are allowed",
 "Al publicarla, los equipos del canal empezarán a descargarla": "Once published, the devices on the channel will start downloading it",
 "Subiendo el paquete": "Uploading the package",
 "Procesando en el servidor: checksum y manifest": "Processing on the server: checksum and manifest",
 "Quitar": "Remove",
 "Buscar versión": "Search version",
 "Ver como tabla": "View as table",
 "Ver como tarjetas": "View as cards",
 "Ninguna versión coincide con la búsqueda": "No version matches the search",
 "Subir un nivel": "Go up one level",
 "Todos los firmwares": "All firmware",
 "Variante": "Variant",
 "canal": "channel",
 "canales": "channels",
 "variante": "variant",
 "variantes": "variants",
 "O pulsa para elegirlo": "Or click to choose it",
 "versión": "version",
 "carpeta": "folder",
 "Selecciona un firmware o un canal para ver su contenido": "Select a firmware or a channel to see its contents",
 "Carpetas": "Folders",
 "Versiones": "Versions",
 "versiones": "versions",
 "carpetas": "folders",
 "Selecciona un canal para ver su contenido": "Select a channel to see its contents",
 "Esta carpeta solo contiene otras carpetas": "This folder only contains other folders",
 "Firmwares": "Firmware",
 "Firmware": "Firmware",
 "En distribución": "Live",
 "Poner en distribución": "Set live",
 "Ninguna versión en distribución": "No version is live",
 "Eliminar y retirar de distribución": "Delete and take out of distribution",
 "Descargar": "Download",
 "Publicada": "Released",
 "Actualizar": "Refresh",
 "Sin firmwares publicados": "No firmware published yet",
 "Selecciona un canal para ver sus versiones": "Select a channel to see its versions",
 "Arrastra aquí el paquete de firmware": "Drop the firmware package here",
 "O pulsa para elegirlo y completar los datos de la versión": "Or click to choose it and fill in the version details",
 "Un firmware o un canal nuevo nace al subir su primera versión": "A new firmware or channel is born when its first version is uploaded",
 "Variante (opcional)": "Variant (optional)",
 "Distingue compilaciones del mismo canal, por ejemplo rpi4": "Tells apart builds of the same channel, for example rpi4",
 "Versiones de firmware": "Firmware versions",
 "Firmware OTA": "OTA firmware",
 "Carpeta": "Folder",
 "Publicada por": "Published by",
 "Archivo": "File",
 "Tamaño": "Size",
 "Acciones": "Actions",
 "Marcar latest": "Set as latest",
 "¿Marcar esta versión como latest?": "Set this version as latest?",
 "Los dispositivos del canal se actualizarán a esta versión": "Devices on this channel will update to this version",
 "¿Borrar la versión latest?": "Delete the latest version?",
 "Es la versión latest del canal: se borrará también el puntero": "It is the channel's latest version: the pointer will also be deleted",
 "Productos": "Products",
 "Subir versión": "Upload version",
 "Versión marcada como latest": "Version set as latest",
 "Versión borrada correctamente": "Version deleted successfully",
 "Las carpetas se crean al subir su primera versión": "Folders are created when their first version is uploaded",
 "Producto": "Product",
 "Canal": "Channel",
 "Target (opcional)": "Target (optional)",
 "Subcarpeta para diferenciar builds, por ejemplo rpi4": "Subfolder to tell builds apart, for example rpi4",
 "Campo obligatorio": "Required field",
 "Seleccionar archivo": "Select file",
 "Marcar como latest": "Set as latest",
 "Formato no permitido": "Format not allowed",
 "Selecciona el archivo de firmware": "Select the firmware file",
 "Versión subida correctamente": "Version uploaded successfully",
 "Subir": "Upload",
 "Caducidad suscripción": "Subscription expiration",
 "Cambiar tarifa": "Change rate",
 "Selecciona la tarifa destino para las tarjetas seleccionadas": "Select the target rate for the selected cards", 
 "Selecciona tarjetas y una tarifa": "Select cards and a rate", 
 "Algunas tarjetas no se pudieron actualizar": "Some cards could not be updated", 
 "Actualizadas": "Updated", 
 "Fallidas": "Failed", 
"Error 404": "404 Error", 
 "Detalles Administrativos": "Administrative Details", 
 "Detalles  M2M": "M2M Details", 
 "Search": "Search", 
 "Reset": "Reset", 
 "Instalaci\u00f3n/Pedido": "Device/Order", 
 "Cliente": "Client", 
 "Estado": "Status", 
 "Desactivada": "Disabled", 
 "Activada": "Activated", 
 "Inactiva nueva": "Inactive new", 
 "Lista para activaci\u00f3n": "Ready for activation", 
 "Desconocido": "Unknown", 
 "Consumo diario": "Daily consumption", 
 "Consumo mensual": "Monthly consumption", 
 "Comienzo \u00faltima conexi\u00f3n": "Start of last connection", 
 "Fin \u00faltima conexi\u00f3n": "End of last connection", 
 "Compa\u00f1\u00eda de red": "Network company", 
 "C\u00f3digo de pa\u00eds": "Country code", 
 "Tipo de red": "Network type", 
 "Tipo de tarifa": "Fee type", 
 "Zona 1": "Zone 1", 
 "Sin asignar": "Not assigned", 
 "Cambiar ciclo vida": "Change lifecycle", 
 "Por favor, seleccione una opci\u00f3n": "Please select an option", 
 "Desactivar": "Deactivate", 
 "Activar": "Activate", 
 "Test": "Test", 
 "Estado GSM": "GSM Status", 
 "Estado GPRS": "GPRS Status", 
 "Buscar": "Search", 
 "Borrar": "Delete", 
 "Nombre": "Name", 
 "Descripci\u00f3n": "Description", 
 "UUID placa": "UUID Board", 
 "Estado instalaci\u00f3n": "Device status", 
 "Desconectada": "Disconnected", 
 "Conectada": "Connected", 
 "Deshabilitada": "Disabled", 
 "Habilitada": "Enabled", 
 "Detalles": "Details", 
 "No se pudieron actualizar los datos": "Failed to update data", 
 "Pools actualizados correctamente": "Pools updated successfully", 
 "Tarjetas activas / tarjetas totales": "Active Cards / Total Cards", 
 "Consumo del pool / Pool total": "Pool consumption / Total pool", 
 "Gasto estimado del pool": "Estimated Pool Expense", 
 "\u00daltima actualizaci\u00f3n": "Last update", 
 "Refrescar": "Refresh", 
 "Actualizar token de acceso": "Refrescar access token", 
 "Por favor, complete este campo": "Please, complete this field", 
 "Enviar": "Send", 
 "Placa creada correctamente": "Board created successfully", 
 "Placa actualizada correctamente": "Board updated successfully", 
 "MAC err\u00f3nea": "Wrong MAC", 
 "SSID err\u00f3neo": "Wrong SSID", 
 "Nuevo kiwi": "New kiwi", 
 "Informaci\u00f3n de kiwi": "Kiwi information", 
 "Guardar": "Save", 
 "UUID err\u00f3neo": "Wrong UUID", 
 "Nuevo kibox": "New kibox", 
 "Informaci\u00f3n de kibox con UUID": "Kibox information with UUID", 
 "Informaci\u00f3n de kibox": "Kibox information", 
 "Habr\u00e1 mas de una placa con ese uuid.\u00bfEst\u00e1 seguro de esto?": "There will be more than one board with that UUID. Are you sure of this?", 
 "Modelo placa": "Board model", 
 "Seleccionar opci\u00f3n": "Select an option", 
 "Tarda demasiado en encenderse": "Takes too long to turn on", 
 "Usuario": "User", 
 "Nombre de usuario": "Username", 
 "Rol": "Role", 
 "Organizaci\u00f3n": "Tenant", 
 "Apellidos": "Last name", 
 "Email": "Email", 
 "Complete los campos obligatorios": "Fill in the required fields", 
 "Las contrase\u00f1as tienen que ser iguales": "Passwords have to be the same", 
 "Nombre de Usuario": "Username", 
 "Correo electr\u00f3nico": "Email", 
 "Contrase\u00f1a": "Password", 
 "Repetir contrase\u00f1a": "Repeat password", 
 "Selecciona organizaci\u00f3n": "Select tenant", 
 "Nivel": "Level", 
 "Selecciona un rol": "Select a role", 
 "Superadministrador": "Superadmin", 
 "Administrador": "Admin", 
 "Operador": "Operator", 
 "Visitante": "Visitor", 
 "Activo": "Active", 
 "Crear cuenta": "Create account", 
 "Inicio": "Start", 
 "Nuevo equipo": "New device", 
 "Stock": "Stock", 
 "Asignaciones": "Assignments", 
 "Lista equipos": "Devices list", 
 "Instalaciones": "Devices", 
 "Listado M2M": "M2M List", 
 "Listado Pools": "Pools list", 
 "Soporte": "Support", 
 "Crear Usuario": "Create user", 
 "Lista Usuarios": "List users", 
 "error": "error", 
 "Informaci\u00f3n de tarjeta M2M con icc": "Information of M2M card with icc", 
 "Alias": "Alias", 
 "Life Cycle Status": "Life Cycle Status", 
 "Pais": "Country", 
 "Plan": "Subscription", 
 "Estado Actual": "Actual status", 
 "\u00daltimo evento": "Last event", 
 "Tecno.Conexi\u00f3n": "Conn.Tech.", 
 "\u00daltima Conexi\u00f3n": "Last connection", 
 "Complete los campos": "Complete the fields", 
 "Inicio de sesi\u00f3n exitoso": "Login successful", 
 "Introduzca un nombre de usuario": "Enter an username", 
 "Introduzca una contrase\u00f1a": "Enter a password", 
 "Iniciar sesi\u00f3n": "Login", 
 "Eliminar": "Delete", 
 "Editar": "Edit", 
 "Asignar": "Assign", 
 "N\u00famero de serie err\u00f3neo": "Wrong serial number", 
 "Nuevo KiWi": "New kiwi", 
 "Pedido": "Order", 
 "N serie": "Serial number", 
 "Fecha fabricaci\u00f3n": "Fabrication date", 
 "Estado de fabricaci\u00f3n": "Manufacturing status", 
 "KiWi terminado": "Kiwi finished", 
 "No se ha podido terminar": "Could not finish", 
 "Terminar": "Finish", 
 "Version hardware": "Hardware version", 
 "Modelo": "Model", 
 "Tipo USB": "USB type", 
 "Instalaci\u00f3n": "Device", 
 "Cliente kiconex": "Kiconex client", 
 "Cliente final": "Final client", 
 "N\u00famero de serie": "Serial number", 
 "kiconex plan": "Kiconex plan", 
 "Nº dispositivos": "Number of devices", 
 "Cuadro": "Frame", 
 "Placa terminada": "Finished board", 
 "Opcionales": "Optionals", 
 "Notas": "Notes", 
 "Crear nuevo dispositivo": "Create new device", 
 "Bienvenido a kicore ¡la plataforma de gesti\u00f3n de Kiconex!": "Welcome to kicore, the Kiconex management platform!", 
 "Ver en kiconex": "View in kiconex", 
 "ICC err\u00f3neo": "Wrong ICC", 
 "Nombre instalaci\u00f3n": "Device name", 
 "Nº serie": "Serial number", 
 "Versi\u00f3n hardware": "Hardware version", 
 "Ninguno": "None", 
 "Chino": "C", 
 "Basic": "Basic", 
 "Professional": "Professional", 
 "Premium": "Premium", 
 "No": "No", 
 "S\u00ed": "Yes", 
 "Cable": "Cable", 
 "Fabricado": "Manufactured", 
 "Asignado": "Assigned", 
 "Terminado": "Finished", 
 "Eliminado": "Deleted", 
 "Volver": "Return", 
 "Plan kiconex": "Kiconex forfait", 
 "¡MAC err\u00f3nea!": "Wrong MAC!", 
 "Introduzca una MAC o IMEI v\u00e1lidos": "Enter a valid MAC or IMEI", 
 "Generar UUID": "Generate UUID", 
 "¡SSID err\u00f3neo!": "Wrong SSID!", 
 "¡UUID err\u00f3neo!": "Wrong UUID!", 
 "¡ICC err\u00f3neo!": "Wrong ICC!", 
 "¡N\u00famero de serie err\u00f3neo!": "Wrong serial number!", 
 "Grupo comercial": "Commercial group", 
 "Habilitaci\u00f3n": "Enablement", 
 "F\u00e1brica": "Factory", 
 "Administraci\u00f3n": "Administration", 
 "Gesti\u00f3n": "Management", 
 "Usuarios": "Users", 
 "Lista kibox": "Kibox list", 
 "Lista kiwi": "Kiwi list", 
 "Kibox asignados": "Assigned kibox", 
 "Kiwis asignados": "Assigned kiwis", 
 "No se conecta al WiFi": "Does not connect to WiFi", 
 "Este pedido debe salir con una pegatina extra": "This order must come out with an extra sticker", 
 "Cambiar estado de la SIM": "Change SIM status", 
 "Estado de la SIM": "SIM Status", 
 "Fruter\u00eda fulanito": "Example fruit store", 
 "Token actualizado correctamente": "Token updated successfully", 
 "Usuario creado correctamente": "User created successfully", 
 "No hay respuesta del servidor": "There is no response from the server", 
 "Error": "Error", 
 "Error al cerrar sesi\u00f3n": "Failed to log out", 
 "Seleccionar idioma": "Select Language", 
 "Espa\u00f1ol": "Spanish", 
 "Ingl\u00e9s": "English", 
 "Franc\u00e9s": "French", 
 "Alem\u00e1n": "Deutsch", 
 "UUID": "UUID", 
 "Nombre comercial": "Commercial name", 
 "Pedido comercial": "Commercial Order", 
 "N\u00famero de serie comercial": "Commercial serial number", 
 "Modelo del equipo": "Equipment model", 
 "Estado Comercial": "Commercial State", 
 "Fecha Conexi\u00f3n": "Date Connection", 
 "Subscripci\u00f3n": "Subscription", 
 "Comercial": "Commercial", 
 "General": "General", 
 "Placa borrada correctamente": "Board erased successfully", 
 "Sistema": "System", 
 "Privilegios": "Privileges", 
 "Roles": "Roles", 
 "Usuario borrado correctamente": "User deleted successfully", 
 "Cambiar contrase\u00f1a": "Change Password", 
 "Columnas": "Columns", 
 "Sin informaci\u00f3n": "No information", 
 "Cerrar": "Close", 
 "Cambiar": "Change", 
 "Por favor, seleccione una opcion": "Please select an option", 
 "¡Las contrase\u00f1as deben coincidir!": "¡Passwords must match!", 
 "La contrase\u00f1a es un campo obligatorio": "Password is a required field", 
 "success": "success", 
 "Contrase\u00f1a actualizada correctamente": "Password updated successfully", 
 "Las contrase\u00f1as deben coincidir": "Passwords must match", 
 "Cambio de contrase\u00f1a usuario": "User password change", 
 "Debe seleccionar un rol": "You must select a role", 
 "Rol creado correctamente": "Role created successfully", 
 "Nuevo Rol": "New Rol", 
 "Informaci\u00f3n de Rol": "Role Information", 
 "Rol borrado correctamente": "Role deleted successfully", 
 "Rol administrador": "Administrator role", 
 "Sincronizar": "Sync up", 
 "¡Sincronizar datos!": "¡Sync data!", 
 "Nombre, Organizaci\u00f3n y subscripci\u00f3n van a ser modificados por el valor que tengan en la plataforma Kiconex \u00bfEst\u00e1 seguro de esto?": "Name, Organization and subscription will be modified by the value they have in the Kiconex platform. Are you sure about this?", 
 "Usuario guardado correctamente": "User saved successfully", 
 "Nuevo usuario": "New user", 
 "Editando usuario": "Edit user", 
 "Software": "Software", 
 "Crear": "Create", 
 "Ver": "See", 
 "Finalizar": "Finish", 
 "Editar comercial": "Edit commercial", 
 "Gesti\u00f3n de placas de f\u00e1brica": "Factory license boards management", 
 "Asignaciones de f\u00e1brica": "Factory assignments", 
 "Asignaci\u00f3n de placas de f\u00e1brica": "Assignment of factory boards", 
 "Gesti\u00f3n de placas de administraci\u00f3n": "Administration Board Management", 
 "mykiconex": "mykiconex", 
 "Gesti\u00f3n con plataforma mykiconex": "Management with mykiconex platform", 
 "M2M": "M2M", 
 "Ver M2M": "See M2M", 
 "Ver estado": "View status", 
 "Ver listado pools": "See pool list", 
 "Refrescar pools": "Refrescar pools", 
 "Actualizar token": "Refrescar token", 
 "VPN": "VPN", 
 "Chat": "Chat", 
 "Ver privilegios": "View privileges", 
 "Editar privilegios": "Edit privileges", 
 "Gesti\u00f3n de sistema": "System management", 
 "Gesti\u00f3n de usuarios": "User Management", 
 "Ver acceso a chat": "View chat access", 
 "Ver acceso a soporte": "See access to support", 
 "Ver acceso a VPN": "See VPN access", 
 "Gesti\u00f3n de tarjetas M2M": "M2M Card management", 
 "Autorizaci\u00f3n": "Authorization", 
 "Portugu\u00e9s": "Portuguese", 
 "Italiano": "Italian", 
 "Fecha primera contrataci\u00f3n": "First hiring date", 
 "Fecha \u00faltima renovaci\u00f3n": "Last renewal date", 
 "Intervalo de renovaci\u00f3n (a\u00f1os)": "Renewal interval (years)", 
 "Fecha primera conexi\u00f3n": "First connection date", 
 "Privilegios guardados correctamente": "Privileges saved correctly", 
 "Rol actualizado correctamente": "Role updated correctly", 
 "N\u00famero Pedido": "Order number", 
 "Asunto": "Subject", 
 "Asignado a": "Assigned to", 
 "Fecha de Creaci\u00f3n": "Creation date", 
 "Pendiente": "Pending", 
 "Cambiar Estado": "Change Status", 
 "Estado del Pedido actualizado correctamente": "Order state updated correctly", 
 "Cliente Final": "Final client", 
 "Referencia Presupuesto": "Budget reference", 
 "Precio Total": "Total price", 
 "Ver en CRM": "See in CRM", 
 "N\u00famero Presupuesto": "Budget number", 
 "En Proceso": "In progress", 
 "Anulado": "Cancelled", 
 "Cambiar estado del pedido": "Change order status", 
 "Pedidos": "Orders", 
 "Gesti\u00f3n de pedidos": "Orders management", 
 "Error en la operaci\u00f3n": "Operation Error", 
 "UUID de placa ya en uso": "Board uuid already in use", 
 "Nueva Placa Guardada": "New saved board", 
 "Placa actualizada": "Updated board", 
 "Placa borrada": "Deleted board", 
 "Placas actualizadas": "Updated boards", 
 "SSID de kiwi ya en uso": "Kiwi ssid already in use", 
 "Nuevo KiWi Guardado": "New kiwi saved", 
 "KiWi actualizado": "Updated Kiwi", 
 "KiWi borrado": "Deleted Kiwi", 
 "Token actualizado": "Token updated", 
 "Nombre de rol ya en uso": "Role name already in use", 
 "Rol actualizado": "Updated role", 
 "No puede eliminar un rol con dependencias": "Cannot eliminate a role with dependencies", 
 "La clave ha expirado.": "The key has expired.", 
 "Usuario no encontrado.": "User not found.", 
 "Las contrase\u00f1as son obligatorias.": "Passwords are mandatory.", 
 "Las contrase\u00f1as no coinciden.": "Passwords do not match.", 
 "Nombre de usuario ya en uso": "User name already in use", 
 "Error del servidor.": "Server error.", 
 "El usuario no ha sido activado.": "The user has not been activated.", 
 "Inicio de sesi\u00f3n con \u00e9xito": "Login successful", 
 "Contrase\u00f1a incorrecta": "Incorrect password", 
 "Fecha Renovaci\u00f3n": "Renewal date", 
 "Tiempo Restante": "Time Left", 
 " meses restantes": " remaining months", 
 "Pedidos a expirar": "Orders to expire", 
 "Descargar Informe": "Download Report", 
 "Renovaciones": "Renovations", 
 "Pr\u00f3ximo mes": "Next month", 
 "Pr\u00f3ximos 3 meses": "Next 3 months", 
 "Pr\u00f3ximos 6 meses": "Next 6 months", 
 "Pr\u00f3ximo a\u00f1o": "Next year", 
 "Ver renovaciones": "See renovations", 
 "Caducada": "Expired", 
 " d\u00edas restantes": " remaining days", 
 "Aceptar": "Accept", 
 "Reiniciar": "Restart", 
 "Sin organizaci\u00f3n": "No organization", 
 "Ver pools": "See pools", 
 "Alarmas": "Alarms", 
 "Alarmas M2M": "Alarms M2M", 
 "Sin alertas": "Without alerts", 
 "Advertencia": "Warning", 
 "Critica": "Critical", 
 "Renovaciones expiradas": "Expired renovations", 
 "Pedidos pendientes": "Pending orders", 
 "Tarjetas desactivadas desde hace mas de 12 meses": "Cards deactivated for more than 12 months", 
 "Ver m\u00e1s": "See more", 
 "Creaci\u00f3n": "Creation", 
 "Actualizaci\u00f3n": "Update", 
 "Borrado": "Erased", 
 "Cambio de estado": "Status change", 
 "Cambio de contrase\u00f1a": "Change of password", 
 "Sincronizaci\u00f3n": "Synchronization", 
 "Sin acci\u00f3n": "No action", 
 "Fecha": "Date", 
 "Acci\u00f3n": "Action", 
 "Tipo de objeto": "Type of object", 
 "Identificador": "Identifier", 
 "Placa": "Board", 
 "Hace 3 horas": "3 hours ago", 
 "Hace 1 d\u00eda": "1 day ago", 
 "Hace 3 d\u00edas": "3 days ago", 
 "Hace 1 semana": "1 week ago", 
 "Actividad": "Activity", 
 "Listado": "List", 
 "Ver actividad": "View activity", 
 "Privilegio": "Privilege", 
 "No es posible personificar desde un personificado.": "It is not possible to personify from a personified.", 
 "Personificaci\u00f3n": "Personification", 
 "Personificando al usuario": "Personifying the user", 
 "Volver a la sesi\u00f3n": "Go to the session", 
 "Personificar": "Personify", 
 "No es posible personificarse a si mismo.": "It is not possible to personify yourself.", 
 "Comienzo Personificaci\u00f3n": "Start Person", 
 "Fin Personificaci\u00f3n": "End personification", 
 "Ajustes": "Settings", 
 "Actualizar listado": "Update list", 
 "Refrescar pedidos": "Refresh orders", 
 "Refrescar ordenes de trabajo": "Refresh work orders", 
 "de": "of", 
 "filtrados de": "filtered from", 
 "Actualizar listado de organizaciones": "Update List of Organizations", 
 "Actualizar nombre, plan y organizaci\u00f3n de kibox": "Update Kibox's name, plan and organization", 
 "Actualizar listado de pedidos": "Update orders list", 
 "Actualizar listado de ordenes de trabajo": "Update work orders list", 
 "Actualizaci\u00f3n de listados": "List update", 
 "Actualizado con exito": "Updated with success", 
 "Activa": "Active", 
 "Sin intervalo": "No interval", 
 "Mostrar todo": "Show everything", 
 "Estado de suscripci\u00f3n no compatible con el intervalo seleccionado": "Subscription status not compatible with the selected interval", 
 "Estado del plan": "Plan status", 
 "Caducado": "Timed out", 
 "Inactivo": "Idle", 
 "Cancelado": "Cancelled", 
 "No procede": "It does not proceed", 
 "¡Orden de trabajo erronea!": "Erroneous work order!", 
 "Rellene el formulario correctamente": "Fill the form correctly", 
 "Orden de trabajo": "Work order", 
 "Su sesi\u00f3n va a ser cerrada": "Your session will be closed", 
 "Su sesi\u00f3n se cerrar\u00e1 para aplicar los cambios": "You will be logged out to apply the changes", 
 "Inicie sesi\u00f3n de nuevo": "Sign in again", 
 "Posee una versi\u00f3n no compatible": "It has a non -compatible version", 
 "Consumo": "Consumption", 
 "Consumo de la SIM": "SIM consumption", 
 "Mensual": "Monthly", 
 "Diario": "Diary", 
 "UUID ya en uso": "UUID already in use", 
 "VPN creada correctamente": "Successfully created VPN", 
 "VPN actualizada correctamente": "Successfully updated VPN", 
 "Contrase\u00f1a copiada al portapapeles": "Password copied to clipboard", 
 "Fallo al copiar la contrase\u00f1a": "Failed to copy password", 
 "Nueva conexi\u00f3n VPN": "New VPN connection", 
 "Regenerar contrase\u00f1a": "Regenerate password", 
 "Contrase\u00f1a VPN": "VPN Password", 
 "Copie la contrase\u00f1a antes de guardar, no volver\u00e1 a ser visible": "Copy the password before saving, it will not be visible again", 
 "VPN (antigua)": "VPN (old)", 
 "Ver acceso a VPN (antigua)": "View VPN access (old)", 
 "Ver VPN (antigua)": "View VPN (old)", 
 "Ver VPN": "View VPN", 
 "Crear VPN": "Create VPN", 
 "Editar VPN": "Edit VPN", 
 "Ver informaci\u00f3n": "See information", 
 "Informaci\u00f3n placas": "Plate information", 
 "Modelo de hardware": "Hardware model", 
 "Fecha de compilaci\u00f3n": "Build date", 
 "Versi\u00f3n de Daemon": "Daemon version", 
 "Fecha de actualizaci\u00f3n": "Update date", 
 "Actualizado": "Updated", 
 "No actualizado": "Not updated", 
 "Descargar fichero de configuraci\u00f3n": "Download configuration file", 
 "Nunca": "Never", 
 "Dispositivo": "Device", 
 "Router kiconex": "Kiconex router", 
 "Fecha de expedici\u00f3n": "Issue date", 
 "\u00bfEst\u00e1 seguro de que desea eliminar este elemento?": "Are you sure you want to delete this item?", 
 "Confirmaci\u00f3n de eliminaci\u00f3n": "Deletion confirmation", 
 "S\u00ed, eliminar": "Yes, delete", 
 "Cancelar": "Cancel", 
 "Unidades de cable": "Cable units", 
 "En espera": "On hold", 
 "En proceso": "In process", 
 "UUID Original": "Original UUID", 
 "El nombre es obligatorio": "Name is required", 
 "UUID no v\u00e1lido": "Invalid UUID", 
 "API Key borrada": "API key deleted", 
 "La fecha de expiraci\u00f3n debe ser posterior a la fecha actual": "The expiration date must be later than the current date", 
 "Clave editada correctamente": "Key successfully edited", 
 "Clave creada correctamente": "Key successfully created", 
 "Clave copiada al portapapeles": "Key copied to clipboard", 
 "\u00bfEst\u00e1s seguro?": "Are you sure?", 
 "No podr\u00e1s volver a ver esta clave API. \u00bfDeseas continuar?": "You will not be able to view this API key again. Do you wish to proceed?", 
 "S\u00ed, cerrar": "Yes, close", 
 "La clave no volver\u00e1 a estar disponible": "The key will no longer be available", 
 "\u00bfDeseas borrar esta clave API?": "Do you want to delete this API key?", 
 "S\u00ed, borrar": "Yes, delete", 
 "Clave borrada correctamente": "Key successfully deleted", 
 "Sin descripci\u00f3n": "No description", 
 "Fecha de expiraci\u00f3n": "Expiration date", 
 "Editar clave API": "Edit API key", 
 "Nueva clave API": "New API key", 
 "Copiar clave": "Copy key", 
 "Clave API creada correctamente": "API key successfully created", 
 "Esta es tu clave API. No podr\u00e1s volver a consultarla en el futuro, c\u00f3piala y \u00fasala donde necesites": "This is your API key. You will not be able to view it again in the future, so copy and use it wherever needed", 
 "Claves API": "API Keys", 
 "Listado de claves API": "API key list", 
 "Generar nueva clave": "Generate new key", 
 "Editar claves": "Edit keys", 
 "Editar tracker": "Edit tracker", 
 "Modelo control": "Control model", 
 "Clave API control": "Control API key", 
 "Clave API box": "Box API key", 
 "Actualizar claves de acceso para: ": "Update access keys for: ", 
 "Traductor de librer\u00edas": "Library Translator", 
 "Estado de subscripci\u00f3n": "Subscription Status", 
 "Versi\u00f3n": "Version", 
 "Sin versi\u00f3n": "No version", 
 "Sin modelo": "No model", 
 "Primero seleccione un modelo": "First select a model", 
 "Tendr\u00e1 que volver a iniciar sesi\u00f3n para usar la nueva clave": "You will need to log in again to use the new key", 
 "El nombre de usuario es un campo obligatorio": "Username is a required field", 
 "Pedido es un campo obligatorio": "Order is a required field", 
 "UUID es un campo obligatorio": "UUID is a required field", 
 "Modelo y versi\u00f3n son campos obligatorios": "Model and version are required fields", 
 "Renovaciones M2M expiradas": "Expired M2M Renewals", 
 "Renovaciones de plan expiradas": "Expired Plan Renewals", 
 "Ingrese el n\u00famero de meses": "Enter the number of months", 
 "Intervalo de renovaci\u00f3n": "Renewal interval", 
 "suscripci\u00f3n": "subscription", 
 "suscripciones": "subscriptions", 
 "Editando": "Editing", 
 "Renovando": "Renewing", 
 "suscripciones actualizadas correctamente": "subscriptions updated successfully", 
 "Pr\u00f3xima renovaci\u00f3n": "Next renewal", 
 "Renovar": "Renew", 
 "\u00bfD\u00f3nde encuentro mi clave?": "Where can I find my key?", 
 "Clave API Cloud": "Cloud API Key", 
 "Clave API Cloud actualizada correctamente": "Cloud API Key updated successfully", 
 "VPN Antigua": "Old VPN", 
 "Meses a renovar": "Months to renew", 
 "Debe seleccionar un estado de suscripci\u00f3n": "You must select a subscription status", 
 "Plan es obligatorio": "Plan is required", 
 "Debe seleccionar un estado de suscripci\u00f3n M2M": "You must select an M2M subscription status", 
 "ICC es obligatorio": "ICC is required", 
 "Hist\u00f3rico de suscripci\u00f3n": "Subscription History", 
 "Fecha de primera conexi\u00f3n": "First Connection Date", 
 "Fecha de renovaci\u00f3n": "Renewal Date", 
 "meses": "months", 
 "Realizado por": "Performed by", 
 "Eliminaci\u00f3n": "Deletion", 
 "Cancelaci\u00f3n": "Cancellation", 
 "Preparaci\u00f3n": "Preparation", 
 "Cambio de intervalo": "Interval Change", 
 "Cambio de plan": "Plan Change", 
 "Caducadas": "Expired", 
 "Por vencer": "Upcoming", 
 "Cargando": "Loading", 
 "Gestionar perfil": "Manage profile", 
 "Instalaci\u00f3n original": "Original installation", 
 "Actualizar en Kite": "Update in Kite", 
 "Debe seleccionar una suscripci\u00f3n de plan": "You must select a plan subscription", 
 "Propietario": "Owner", 
 "Tarifa": "Rate", 
 "Nueva fecha": "New date", 
 "Error al crear usuario": "Error creating user", 
 "Error al obtener datos": "Error fetching data", 
 "Error al cargar las claves API": "Error loading API keys", 
 "Error al guardar la clave": "Error saving key", 
 "Error al borrar la clave": "Error deleting key", 
 "Error al editar la clave": "Error editing key", 
 "Error al copiar la clave": "Error copying key", 
 "No puedes cambiar la fecha de expiraci\u00f3n una vez creada": "You cannot change the expiration date once it has been created", 
 "No se puede devolver a Stock: la placa tiene repuestos asignados": "Cannot return to Stock: the board has assigned spare parts", 
 "Introduzca su correo electr\u00f3nico": "Enter your email address", 
 "Si el correo existe, recibir\u00e1 un mensaje con instrucciones para restablecer su contrase\u00f1a.": "If the email exists, you will receive a message with instructions to reset your password.", 
 "Enviar enlace de recuperaci\u00f3n": "Send recovery link", 
 "Volver al inicio de sesi\u00f3n": "Back to login", 
 "Nueva contrase\u00f1a": "New password", 
 "Restablecer contrase\u00f1a": "Reset password", 
 "El enlace de recuperaci\u00f3n ha caducado o ya ha sido utilizado. Solicite uno nuevo.": "The recovery link has expired or has already been used. Please request a new one.", 
 "Error al restablecer la contrase\u00f1a": "Error resetting password", 
 "\u00bfOlvid\u00f3 su contrase\u00f1a?": "Forgot your password?", 
 "Su contrase\u00f1a ha caducado": "Your password has expired", 
 "Han pasado m\u00e1s de 6 meses desde el \u00faltimo cambio. Por motivos de seguridad debe establecer una nueva contrase\u00f1a antes de continuar.": "More than 6 months have passed since the last change. For security reasons, you must set a new password before continuing.", 
 "Entendido": "Understood", 
 "La contrase\u00f1a debe tener al menos 12 caracteres.": "The password must be at least 12 characters long.", 
 "La contrase\u00f1a debe incluir al menos tres de las siguientes categor\u00edas: may\u00fasculas, min\u00fasculas, n\u00fameros y caracteres especiales.": "The password must include at least three of the following categories: uppercase, lowercase, numbers and special characters.", 
 "Cambiar ahora": "Change now", 
 "Su contrase\u00f1a caducar\u00e1 pronto": "Your password will expire soon", 
 "Le quedan {days} d\u00edas para cambiar su contrase\u00f1a. Pulse el bot\u00f3n para hacerlo ahora.": "You have {days} days left to change your password. Click the button to do it now.", 
 "copiado al portapapeles": "copied to clipboard",
 "C\u00f3digos copiados al portapapeles": "Recovery codes copied to clipboard",
 "C\u00f3digos de recuperaci\u00f3n": "Recovery codes",
 "Gu\u00e1rdelos en un lugar seguro. No se volver\u00e1n a mostrar. Cada uno sirve una sola vez si pierde el acceso a su aplicaci\u00f3n.": "Keep them in a safe place. They will not be displayed again. Each one can be used once if you lose access to your application.",
 "Copiar c\u00f3digos": "Copy codes",
 "Introduzca el c\u00f3digo": "Enter the code",
 "C\u00f3digo incorrecto": "Incorrect code",
 "Verificaci\u00f3n en dos pasos desactivada": "Two-factor verification disabled",
 "Verificaci\u00f3n en dos pasos": "Two-factor verification",
 "Introduzca uno de sus c\u00f3digos de recuperaci\u00f3n para desactivar la verificaci\u00f3n en dos pasos.": "Enter one of your recovery codes to disable two-factor verification.",
 "C\u00f3digo de recuperaci\u00f3n": "Recovery code",
 "Desactivar 2FA": "Disable 2FA",
 "Usar el c\u00f3digo de la aplicaci\u00f3n": "Use the app code",
 "\u00bfNo tiene acceso a la app? Usar un c\u00f3digo de recuperaci\u00f3n": "No access to the app? Use a recovery code",
 "Su cuenta est\u00e1 protegida con un segundo factor. Para desactivarlo, introduzca un c\u00f3digo de su aplicaci\u00f3n de autenticaci\u00f3n.": "Your account is protected with a second factor. To disable it, enter a code from your authentication application.",
 "\u00d1ade una capa extra de seguridad. Necesitar\u00e1 una app como Google Authenticator para generar los c\u00f3digos.": "Add an extra layer of security. You will need an app like Google Authenticator to generate the codes.",
 "1. Escanee el c\u00f3digo QR con su aplicaci\u00f3n de autenticaci\u00f3n": "1. Scan the QR code with your authentication application",
 "\u00bfNo puede escanear? Introduzca esta clave manualmente": "Can't scan? Enter this key manually",
 "2. Introduzca el c\u00f3digo de 6 d\u00edgitos que muestra la app": "2. Enter the 6-digit code shown by the app",
 "Su contrase\u00f1a ha caducado": "Your password has expired",
 "Error al obtener datos": "Error fetching data",
 "Error al copiar": "Failed to copy",
 "Tarifa es obligatorio": "Rate is required",
 "M2M actualizado correctamente": "M2M successfully updated",
 "Error al actualizar M2M": "Error updating M2M",
 "Enlace no v\u00e1lido o expirado. P\u00eddalo de nuevo o p\u00f3ngase en contacto con un administrador.": "Invalid or expired link. Request it again or contact an administrator.",
 "Datos personales": "Personal data",
 "Seguridad y acceso": "Security and access",
 "Zona horaria": "Time zone",
 "Seleccione una zona horaria": "Select a time zone",
 "Sin instalaci\u00f3n": "No device",
 "Cambiar clave API Cloud": "Change Cloud API Key",
 "Librerías": "Libraries",
 "Plantillas": "Templates",
 "No tiene configurada una clave API Cloud": "You do not have a Cloud API key configured",
 "El traductor de librerías necesita su clave API Cloud para acceder a las librerías.": "The library translator needs your Cloud API key to access the libraries.",
 "Configurar clave": "Configure key",
 "UUID copiado al portapapeles": "UUID copied to the clipboard",
 "Error al copiar el UUID": "Error copying the UUID",
 "Idioma por defecto": "Default language",
 "Traducir": "Translate",
 "Copiar UUID": "Copy UUID",
 "Traducir con IA": "Translate with AI",
 "Elija un contexto para poder traducir": "Choose a context in order to translate",
 "Parámetro": "Parameter",
 "origen": "source",
 "librería": "library",
 "plantilla": "template",
 "Contexto de traducción": "Translation context",
 "con error": "with errors",
 "cancelando…": "cancelling…",
 "pausando…": "pausing…",
 "en pausa": "paused",
 "Guardar y cerrar": "Save and close",
 "Traducir todo": "Translate all",
 "Traducir seleccionadas": "Translate selected",
 "Pausar": "Pause",
 "Continuar": "Continue",
 "El texto en el idioma origen está vacío": "The text in the source language is empty",
 "No se ha podido traducir": "Could not translate",
 "Falta configurar la URL del WebSocket del traductor": "The translator WebSocket URL is not configured",
 "No hay traducciones pendientes": "There are no pending translations",
 "No quedan traducciones pendientes": "No pending translations remain",
 "Traducción en pausa": "Translation paused",
 "Traducción cancelada": "Translation cancelled",
 "Traducción terminada": "Translation finished",
 "Error en el proceso de traducción": "Error in the translation process",
 "Corrija las traducciones no válidas antes de guardar": "Fix the invalid translations before saving",
 "Traducciones guardadas": "Translations saved",
 "No se han podido guardar las traducciones": "Could not save the translations",
 "No se han podido cargar los parámetros de la librería": "Could not load the library parameters",
 "La traducción no puede superar los {max} caracteres": "The translation cannot exceed {max} characters",
 "La traducción contiene caracteres no válidos": "The translation contains invalid characters",
 "La traducción por defecto no puede estar vacía": "The default translation cannot be empty",
 "Clave API Cloud no válida": "Invalid Cloud API Key",
 "Revise su clave API Cloud para poder usar el traductor de librerías.": "Check your Cloud API Key to use the library translator.",
 "Revisar clave": "Check key",
 "cambios sin guardar": "unsaved changes",
 "Acceso al traductor de librerías": "Access to the library translator",
 "sólo no válidas": "invalid only",
 "No tiene permiso para modificar esta librería": "You do not have permission to modify this library",
 "Asignar router": "Assign router",
 "Contraseña del dispositivo": "Device password",
 "Crear box": "Create box",
 "Crear router": "Create router",
 "Duplicado": "Duplicate",
 "El modem ya no está disponible": "The modem is no longer available",
 "Este dispositivo no tiene ningún modem Teltonika asociado": "This device has no Teltonika modem associated",
 "Este dispositivo no tiene ningún router kiconex asignado": "This device has no Kiconex router assigned",
 "Exportar a Excel": "Export to Excel",
 "Falta el número de serie": "Serial number missing",
 "Falta la MAC": "MAC missing",
 "Falta la contraseña": "Password missing",
 "Fecha alta": "Creation date",
 "Fichero": "File",
 "Fila": "Row",
 "IMEI no válido": "Invalid IMEI",
 "Importar": "Import",
 "Importar modems": "Import modems",
 "Información de modem": "Modem information",
 "Información de router": "Router information",
 "Libres": "Free",
 "MAC no válida": "Invalid MAC",
 "Modem": "Modem",
 "Modem Teltonika": "Teltonika modem",
 "Modem borrado correctamente": "Modem deleted successfully",
 "Modem es un campo obligatorio": "Modem is a required field",
 "Modems importados": "Modems imported",
 "No se ha podido cargar la información del router": "Router information could not be loaded",
 "No se ha podido leer el fichero": "The file could not be read",
 "Nuevo modem": "New modem",
 "Nuevo repuesto": "New spare",
 "Nuevo router": "New router",
 "Observaciones": "Remarks",
 "Organización es un campo obligatorio": "Tenant is a required field",
 "Repetido en el fichero": "Repeated in the file",
 "Revisa los campos marcados": "Check the highlighted fields",
 "Router": "Router",
 "Router (dato antiguo)": "Router (legacy data)",
 "Router borrado correctamente": "Router deleted successfully",
 "Router no disponible": "Router not available",
 "Router terminado": "Router finished",
 "Seleccionar fichero": "Select file",
 "Seleccionar router": "Select router",
 "Sin modem Teltonika": "No Teltonika modem",
 "Sin tipo": "No type",
 "Stock Kiconex": "Kiconex stock",
 "Stock Teltonika": "Teltonika stock",
 "Tipo": "Type",
 "Tipo Teltonika": "Teltonika type",
 "Tracker": "Tracker",
 "Transformados": "Transformed",
 "UUID router": "Router UUID",
 "Versión placa": "Board version",
 "Válido": "Valid",
 "Ya existe en el sistema": "Already exists in the system",
 "duplicadas": "duplicates",
 "filas leídas": "rows read",
 "válidas": "valid",
 "¡IMEI erróneo!": "Wrong IMEI!",
 "Lista routers": "Router list",
 "Routers asignados": "Assigned routers",
 "Seleccionar ICC": "Select ICC",
  "Se deben renovar al menos": "Must renew at least",
},
  "plural": "(n != 1)"
  };
